<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>
    <div style="margin-top:4rem;overflow-y:auto;" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-delay=500>
        <div v-for="(item,i) in lists">
                <div class="newsCard" @click="toLinkNews(item.id)">
                    <el-image
                    style="width: 12.25rem; height: 11.25rem; float: left"
                    :src="item.cover"
                    fit="fill"
                    ></el-image>
                    <div class="newsIn">
                        <div class="newsTitle">{{ item.created_time }}</div>
                        <div class="newsContext">{{ item.title }}</div>
                    </div>
                </div>
        </div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  created () {
    this.getNewsList()
    this.local()
  },
  computed: {
    disabled () {
      return this.loading
    }
  },
  methods: {
    local () {
      var storage = window.localStorage
      if (!storage) {
        return false
      } else {
        if (storage.getItem('news')) {
          var news = JSON.parse(storage.getItem('news'))
          if (news.image.code === 200) {
            this.image = news.image.data.image
          }
          if (new Date().getTime() - news.time > 6500000) {
            storage.removeItem('news')
          }
        } else {
          this.getNewsList()
        }
      }
    },
    toLinkNews (index) {
      this.$router.push({
        path: '/news/detail',
        query: {
          type: '1',
          id: index,
        },
      })
    },
    async getNewsList () {
      const { data: data } = await api.getNews(this.count)
      const { data:res } = await api.getNewsImage()
      if (res.code === 200){
          this.image = res.data.image
      }
      var curr = new Date().getTime()
      window.localStorage.setItem('news',JSON.stringify({
              time:curr,
              image:res
          }))
      if (data.code === 200) {
        console.log('新闻', data)
        this.list = data.data.results
        this.page_count = data.data.page_count
        this.count++
        this.list.forEach(item => {
          this.lists.push(item)
        })
      }
    },
    load () {
      console.log('我是页面触底加载')
      this.loading = true
      if (this.count <= this.page_count) {
        this.getNewsList()
      }
      this.loading = false
    },
  },
  data () {
    return {
      loading: false,
      image: '',
      page_count: 0,
      // url放api的网络图片
      lists: [],
      list: [],
      count: 1,
    }
  },

  components: {
    // Header
    Tabbar,
    Logo,
  },
}
</script>

<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.newsCard {
  width: 43.875rem;
  height: 11.25rem;
  margin: 1rem 1.5rem;
}
.newsIn {
  float: left;
  width: 31.625rem;
  height: 11.25rem;
  background-color: #f5f5f5;
}
.link {
  text-decoration: none;
}
.newsTitle {
  font-size: 1.5rem;
  color: #333333;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  line-height: 2rem;
  display: flex;
  align-items: center;
  padding-left: 1rem;
  padding-top:1rem;


}
.newsContext {
  font-size: 1.75rem;
  color: #333333;
  font-family: PingFang SC;
  font-style: normal;
  /* font-weight: 500; */
  line-height: 2.5375rem;
  padding-left: 1rem;
  padding-top:1rem;
  padding-right: 1.5rem;

}
</style>
